import { useState } from "react";
import PropTypes from "prop-types";

import {
  connect,
  Row,
  Col,
  Tab,
  Nav,
  CustomContainer,
} from "components/atoms/DependencyHelper";
import TooltipContainer from "components/atoms/toolTip/Tooltip";

import {
  link as AnalyticsLink
} from "services/analyticsUtag";

import {
  numberFormat,
  getSpecs,
  formatBytes,
} from "utils/helperServices";

import styles from "./DealDetailFooterTop.module.scss";

import labels from "../../../config/labels";
import config from "../../../config/index";

const env = config.env;
const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;

const DealDetailsFooterTop = ({
  activeContract,
  anyTimeProduct,
  contractsList,
  extraProductsUnderContract,
  isSim,
  primaryProduct,
}) => {
  let planData = [];

  let tabNames = [
    {
      key: "DESC",
      title: labels.deal_details.lbl_deal_details,
      hidden: true,
    },
    {
      key: "SPEC",
      title: isSim
        ? labels.deal_details.lbl_plan_details
        : labels.deal_details.lbl_device_plan_details,
      hidden: true,
    },
    {
      key: "ACC",
      title: labels.deal_details.lbl_acc_voucher_details,
      hidden: true,
    },
  ];

  const firstTabActive = tabNames.find(tab => !tab.hidden);

  const [activeTab, setActiveTab] = useState(firstTabActive?.key || "DESC");

  extraProductsUnderContract = extraProductsUnderContract.filter(
    (obj) => obj.badges != "" || obj.badges !== null
  );

  const renderDescription = (index) => {
    const dealDeviceData = [
      {
        label: labels.deal_details.device_data.lbl_deal_price,
        value: "R" + numberFormat(activeContract?.monthly_recurring) + " PM",
      },
      {
        label: labels.deal_details.device_data.lbl_contract_duration,
        value:
          activeContract?.payment_terms_label +
          " " +
          labels.lbl_months.toLowerCase(),
      },
      {
        label: labels.deal_details.device_data.lbl_available_online,
        value: activeContract?.stock_status == "OUT_OF_STOCK" ? "No" : "Yes",
      },
    ];

    return (
      <CustomContainer
        className={styles["details-deal-sub-section"]}
        key={index}
      >
        {renderData(dealDeviceData)}
      </CustomContainer>
    );
  };

  const renderData = (dealData) => {
    return dealData.map((deal, index) => {
      return deal.value ? (
        <Row
          className={`mx-0 ${styles["details-section-row"]}`}
          key={`row-${index}`}
        >
          <Col
            md={4}
            xs={activeTab == "DESC" ? 6 : 12}
            className={`${styles["details-label"]} pl-m`}
          >
            {deal?.displayLabel || deal.label}:
          </Col>
          <Col
            md={8}
            xs={activeTab == "DESC" ? 6 : 12}
            className={styles["details-value"]}
          >
            {deal.value}
            {deal?.icon && deal?.toolData && deal?.toolData.length > 0 && (
              <div className={styles["tool-tip"]}>
                <TooltipContainer>
                  <div>
                    {deal?.toolData?.map((data) => {
                      return (
                        <div
                          className={styles.description}
                          key={data?.contract_type_option_label}
                        >
                          <div className={`d-flex ${styles.title}`}>
                            {data?.contract_type_option_label}
                          </div>
                          <div className={`d-flex`}>
                            {data?.contract_type_desc}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </TooltipContainer>
              </div>
            )}
            {deal?.linkName && deal?.visibility && (
              <span
                role="link"
                className={styles["deal-details-link"]}
                onClick={() => handleClick(deal.linkKey)}
              >
                {" "}
                {deal.linkName}{" "}
              </span>
            )}
          </Col>
        </Row>
      ) : (
        ""
      );
    });
  };

  const handleClick = (key) => {
    let path;
    let accessory;

    switch (key) {
      case "details":
        path = `${shoppingUrlPrefix}/product-details/${primaryProduct?.sku}`;
        break;
      case "accessory":
        accessory = extraProductsUnderContract.find(
          (product) => product.badges_label === "Accessory"
        );
        path = `${shoppingUrlPrefix}/product-details/${accessory?.sku}`;
        break;
      case "voucher-details":
        path = activeContract?.promotion_link;
    }
    window.open(path, "_blank");
  };

  const renderSpecifications = (productDetalis, planDetails) => {
    const deviceData = productDetalis && [
      {
        label: "Device name",
        value: productDetalis?.name,
      },
      ...getSpecs(productDetalis),
    ];
    const PlanData = planDetails && [
      { label: "Plan name", value: planDetails?.name },
      {
        label: "Anytime data allocation",
        value: planDetails?.promo_data
          ? formatBytes(planDetails?.promo_data)
          : null,
      },
      {
        label: "Night owl data allocation",
        value: `${planDetails?.nightowl_units}${
          planDetails?.nightowl_uom ? planDetails?.nightowl_uom : ""
        }`,
      },
      { label: "Voice minutes", value: planDetails?.minutes_label },
      {
        label: "Air time",
        value: planDetails.airtime ? "R" + planDetails.airtime : 0,
      },
      { label: "SMS", value: planDetails?.sms },
      {
        label: "Contract type",
        value: activeContract?.contract_type_label,
        icon: true,
        toolData: contractsList?.filter((item) => {
          if (
            item.contract_type_option_label ===
            activeContract?.contract_type_label
          ) {
            return item;
          }
        }),
      },
    ];
    if (PlanData != undefined || PlanData != null) {
      planData = PlanData.filter((item) => item.value != "null");
    }
    return (
      <CustomContainer>
        {/* donot display device details for sim */}
        {productDetalis && !isSim && (
          <>
            <label className={styles["details-sub-header-one"]}>
              Device details
            </label>
            <CustomContainer
              className={`${styles["details-deal-sub-section"]} ${styles["sub-section-mobile-styling"]}`}
            >
              {renderData(deviceData)}
            </CustomContainer>
          </>
        )}
        {planDetails && (
          <>
            <label className={styles["details-sub-header-two"]}>
              Plan details
            </label>
            <CustomContainer
              className={`${styles["details-deal-sub-section"]} ${styles["sub-section-mobile-styling"]}`}
            >
              {renderData(planData)}
            </CustomContainer>
          </>
        )}
      </CustomContainer>
    );
  };

  const renderVocherDetails = (index) => {
    const accessory = extraProductsUnderContract.find(
      (product) => product.badges_label === "Accessory"
    );
    const voucher = extraProductsUnderContract.find(
      (product) => product.badges_label === "Voucher"
    );
    const doubleDevice = extraProductsUnderContract.find(
      (product) => product.badges_label === "Device"
    );
    const doublePlan = extraProductsUnderContract.find(
      (product) => product.badges_label === "Plan"
    );
    const AccessoryData = accessory && [
      {
        label: "Accessory name ",
        value: accessory?.name,
      },
      ...getSpecs(accessory),
    ];

    const VoucherData = voucher && [
      {
        label: "Voucher name",
        value: voucher?.name,
        linkName: "View voucher redemption details",
        linkKey: "voucher-details",
        visibility: voucher?.promotion_link,
      },
    ];
    return (
      <CustomContainer key={index}>
        {accessory && (
          <>
            <label className={styles["details-sub-header-one"]}>
              Accessory details
            </label>
            <CustomContainer
              className={`${styles["details-deal-sub-section"]} ${styles["sub-section-mobile-styling"]}`}
            >
              {renderData(AccessoryData)}
            </CustomContainer>
          </>
        )}
        {renderSpecifications(doubleDevice, doublePlan)}
        {voucher && (
          <>
            <label className={styles["details-sub-header-two"]}>
              Voucher details
            </label>
            <CustomContainer
              className={`${styles["details-deal-sub-section"]} ${styles["sub-section-mobile-styling"]}`}
            >
              {renderData(VoucherData)}
            </CustomContainer>
          </>
        )}
      </CustomContainer>
    );
  };

  const renderTabs = () => {
    const footerTabs = tabNames.reduce((acc, tab, index) => {
      if (tab.hidden) return acc;

      const _tab = {
        ...tab,
      }

      switch(tab.key) {
        case "DESC":
          _tab.component = renderDescription(`desc-${index}`);
          break;

        case "SPEC":
          _tab.component = renderSpecifications(
            primaryProduct,
            anyTimeProduct,
            `spec-${index}`
          );
          break;

        case "ACC":
          _tab.component = renderVocherDetails(`acc-${index}`)
          break;

        default: 
          _tab.component = null;
          break;
      }

      return [...acc, _tab];
    }, []);

    return footerTabs;
  };

  const getTabName = (key, tabs) => {
    const total = tabs.length;
    for (let i = 0; i < total; i++) {
      if (key === tabs[i].key) {
        return tabs[i].title;
      }
    }
  };

  const handleTabChange = (eventKey) => {
    setActiveTab(eventKey);
    AnalyticsLink({
      page_tool_event: "use",
      page_tool_name: `shopping: deal details: ${getTabName(
        eventKey,
        tabNames
      )}`,
    });
  };

  if (!firstTabActive) return null;

  const tabList = renderTabs();

  return (
    <>
      <CustomContainer className={`${styles["line-seperator"]}`} />

      <CustomContainer className={`${styles["product-indicator-container"]}`}>
        <CustomContainer className={`${styles["deal-detail-wrapper"]}`}>
          <Tab.Container
            id="product-fbt"
            className={styles["deal-detail-nav-container"]}
            defaultActiveKey={activeTab}
            onSelect={handleTabChange}
          >
            <div>
              <Nav variant="tabs" className={styles["nav-tabs"]}>
                { tabList.map((tab, index) => (
                  <Nav.Item key={index} bsPrefix={"mt-0"}>
                    <Nav.Link
                      eventKey={tab.key}
                      bsPrefix={`${styles["tab-link"]} ${
                        activeTab === tab.key ? styles["tab-link--active"] : ""
                      }`}
                    >
                      {tab.title}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <CustomContainer className={`${styles["nav-line-seperator"]}`} />
            </div>
            <div>
              <Tab.Content className={`${styles["tab-content"]}`}>
                { tabList.map((tab, index) => (
                  <Tab.Pane key={index} eventKey={tab.key}>
                    {tab.component}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </div>
          </Tab.Container>
        </CustomContainer>
      </CustomContainer>

      <CustomContainer className={styles["line-seperator"]} />
    </>
  );
};

DealDetailsFooterTop.propTypes = {
  isSim: PropTypes.bool,
  
  // Redux
  activeContract: PropTypes.object,
  anyTimeProduct: PropTypes.object,
  contractsList: PropTypes.arrayOf(PropTypes.shape({
    contract_type_desc: PropTypes.string,
    contract_type_option_label: PropTypes.string,
  })),
  extraProductsUnderContract: PropTypes.arrayOf(PropTypes.object),
  primaryProduct: PropTypes.object,
};

const mapStateToProps = (state) => ({
  activeContract: state.dealDetails.selectedDealDetails,
  anyTimeProduct: state.dealDetails.dataPlanDetails,
  contractsList: state.dealDetails.contractsList,
  extraProductsUnderContract: state.dealDetails.dealInclusions,
  primaryProduct: state.dealDetails.primaryProduct,
});

export default connect(mapStateToProps, {})(DealDetailsFooterTop);
